import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Heading5, Icon, PageLink, Paragraph } from "shared/components";
import { formatDate, truncateText } from "shared/utils";

import styles from "./Item.module.scss";

const DEFAULT_VISIBLE_LETTERS = 120;

export const Item = ({
  course,
  heading,
  description,
  appearance,
  startDate,
}) => {
  const { locale } = useRouter();

  const truncatedDescription = useMemo(() => {
    return truncateText(description, DEFAULT_VISIBLE_LETTERS);
  }, [description]);

  const date = useMemo(() => {
    return formatDate(startDate, locale);
  }, [startDate, locale]);

  return (
    <PageLink directory="programs" slug={course?.slug} className={styles.link}>
      <div
        className={classNames(styles.wrapper, {
          [styles["grey"]]: appearance === "light",
        })}
      >
        <div className={styles["content-inner"]}>
          <div>
            <Heading5 className={styles.title} color="dark">
              {heading}
            </Heading5>
            <RichText value={truncatedDescription} className={styles.courses} />
          </div>
          <Paragraph color="grey" appearance="smaller">
            {date}
          </Paragraph>
        </div>
        <span className={styles.arrow}>
          <Icon className={styles.icon} name="arrow_right" />
        </span>
      </div>
    </PageLink>
  );
};
